<template>
    <div class="w-full flex flex-row mb-3 xl:mb-5 align-items-center cursor-pointer
        xl:max-w-30rem lg:max-w-30rem md:max-w-30rem"
        @click="popup_show()">
        <div class="w-full flex flex-row border-round-2xl surface-300 py-5 px-3">
            <span class="flex flex-1 text-700 font-medium xl:text-xl">
                {{ header[lang_] }}
            </span>
            <i class="pi pi-window-maximize text-700" style="font-size: 1rem"></i>
        </div>
    </div> 
    <Dialog v-model:visible="popup" modal :header="header[lang_]" 
        class="w-full ml-4 mr-4 border-round-xl" style="max-width: 560px;">
        <div class="w-full">
            <p>
                {{ content[lang_].step1 }}
            </p>
            <p>
                {{ content[lang_].step2 }}
            </p>
            <p>
                {{ content[lang_].step3 }}
            </p>
            <p>
                {{ content[lang_].step4 }}
            </p>
            <p>
                {{ content[lang_].step5 }}
            </p>
            <p>
                {{ content[lang_].step6 }}
            </p>
        </div>
    </Dialog>
</template>


<script>
import { ref } from "vue";
import Helper from '@/assets/js/Helper'
export default {
    props: [],
	data(){
		return{
            popup: false,
            header: {
                ru: "Как снять наличные в магазинах Indomaret",
                en: "How to withdraw cash at Indomaret stores",
            },
			content: {
                ru: {
					step1: "1. Найдите магазин Indomaret в вашем городе.",
                    step2: "2. Скажите продавцу, что вы хотите снять наличные через систему Indomaret.",
                    step3: "3. Назовите оператору ваш номер телефона, который указан в переводе.",
                    step4: "4. Запросите код подтверждения у оператора.",
                    step5: "5. Кассир выдаст вам наличные. Готово.",
				},
				en: {
					step1: "1. Find an Indomaret store in your city.",
                    step2: "2. Tell the cashier that you want to withdraw cash through the Indomaret system.",
                    step3: "3. Tell the operator your phone number, which is indicated in the transfer.",
                    step4: "4. Request a confirmation code from the operator.",
                    step5: "5. The cashier will give you cash. Done.",
                },
			}, 
		}
	},
	computed: {
		lang_() {
			return (this.$i18n.locale) ? this.$i18n.locale : 'ru'
		},
	},
	methods: {
        popup_show(){
            this.popup = true
        },
	},
	async beforeCreate() {
        this.helper = new Helper()
	}
}
</script>